export const normalizeAddressInput = (raw: string): string =>
  raw
    .replace(/[\r\n]+/g, ' ')
    .replace(/\\[nr]/g, '')
    .replace(/\s*-\s*/g, '-')
    .replace(/\s+/g, ' ')
    .trim();
